// eslint-disable-next-line import/no-cycle
import dashboard from './dashboard';
import users from './users';
import collection from './collection';
import reports from './reports';

export default {
  namespaced: true,
  modules: {
    dashboard,
    users,
    collection,
    reports,
  },
};
